import { Plus, Gift, Mail, Crosshair, Award, Home } from 'react-feather';

const additionalSections = [
    {
        key: 'customFields',
        icon: Plus,
        title: 'Campos personalizados',
        description: 'Colete informações extras dos participantes durante a inscrição.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.customFields?.length || 0;
            return count > 0 ? `${count} campo${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'giveaway',
        icon: Gift,
        title: 'Sorteador',
        description: 'Faça sorteios e distribua prêmios entre os participantes.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.giveaways?.length || 0;
            return count > 0 ? `${count} sorteio${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'faq',
        icon: Mail,
        title: 'FAQ do evento',
        description: 'Crie uma seção de Perguntas Frequentes para seus participantes.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.faq?.length || 0;
            return count > 0 ? `${count} pergunta${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'pixels',
        icon: Crosshair,
        title: 'Pixels de rastreamento',
        description: 'Monitore conversões e otimize suas campanhas.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.pixels?.length || 0;
            return count > 0 ? `${count} pixel${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'certificate',
        icon: Award,
        title: 'Geração de certificados',
        description: 'Crie e personalize certificados para os participantes.',
        comingSoon: false,
        getBadge: (data) => {
            return data?.certificate ? 'Configurado' : 'Nenhum';
        }
    },
    {
        key: 'local',
        icon: Home,
        title: 'Características do local',
        description: 'Destaque as características e comodidades do local do evento.',
        comingSoon: true,
        getBadge: () => 'Em breve'
    }
];

export default additionalSections;
